export const KLIKS_APP = 'Kliks App';
export const SYSTEM_ADMIM = 'System Admin';
export const BACK_OFFICE = 'Back Office';
